module.exports = __webpack_public_path__ + "img/long run.1a027906.jpg";